import { Controller } from '@hotwired/stimulus'
import type ModalController from './modal-controller'
import type FormController from './form-controller'

type NavigationEvent = CustomEvent<{ url: string }>

export default class extends Controller {
  static outlets = ['form', 'modal']

  private currentNavigation: NavigationEvent | undefined

  declare formOutlets: FormController[]
  declare modalOutlet: ModalController

  onUnload (event: BeforeUnloadEvent): void {
    if (this.hasUnsavedForm) {
      event.preventDefault()
      event.returnValue = ''
    }
  }

  onNavigation (event: NavigationEvent): void {
    if (this.hasUnsavedForm) {
      event.preventDefault()
      this.currentNavigation = event
      this.modalOutlet.show()
    }
  }

  navigate (): void {
    this.unsavedForm.cleanse()

    this.modalOutlet.hide()

    const url = this.currentNavigation?.detail.url
    if (url !== undefined) Turbo.visit(url)
  }

  submit (): void {
    this.unsavedForm.submit()
    this.navigate()
  }

  private get unsavedForm (): any {
    return this.formOutlets.find((outlet) => outlet.dirty)
  }

  private get hasUnsavedForm (): boolean {
    return this.unsavedForm !== undefined
  }
}
